<template>
	<div class="mid_scroll_content onlyEchange-page h-100vh">
		<loader v-show="pageLoader"></loader>
		<section class="cap_main_chart border-0 h-100" v-if="tradingAccount.length > 0 && tradingAccount[0].subAccounts.length > 0">
			<div v-if="step == '1'" class="h-100">
				<div class="cap_exhange_cur h-100">
					
					<div class="row justify-content-center align-items-center h-100"><!-- {{send}}{{uniqueCurrencyList(send)}} -->
						<div class="col-12 mob-padnone">
							<div class="row justify-content-center custom-max-width">
								<div class="col-12 col-lg-6">
									<alert-notification v-if="notification_msg != ''"/>
									<div class="section_title mb-0">
										<h5>Send</h5>
									</div>
									<div class="six">
										<div class="cursiveLeft">
										<div class="select_cur" @click.stop="showSend = !showSend;showReceive = false">
											<div class="dropdown cap_fund cur_ico">
												<button class="no-border cap_btn dropdown-toggle" type="button">
													<img class="cp__ico" :src="'../../../../static/website/images/crypto_logos/'+ send.currency.toLowerCase()  +'.png'" alt="" @error="handleImgErr($event)" v-if="send != '' && checkImage(send.currency)">
													<span class="firstName" v-else-if="send != ''">{{send.currency.charAt(0)}}</span> {{send.currency}}
												</button>
											</div>
										</div>
										<div class="dropdown-menu rounded" :class="(showSend)?'show':''">
											<div class="cur_search showSend">
												<input type="Search" placeholder="Search here" class="searchcrypto" v-model="searchSend" id="sendSearch" autocomplete="off">
											</div>
											<div class="scrolling_text" v-if="tradingAccount.length > 0">
												<a class="dropdown-item" href="#" v-for="(value,key) in marginSearch(margin_list)" @click.prevent="ChangeSendData(value,key);searchSend = ''" :class="(value.currency == send.currency)?'active':''">
													<img :src="'../../../../static/website/images/crypto_logos/'+value.currency.toLowerCase()+'.png'" alt="" @error="handleImgErr($event)" v-if="checkImage(value.currency)">
													<span class="firstName" v-else>{{value.currency.charAt(0)}}</span>
													{{value.currency}}
													<span class="muted">{{value.currency}}</span>
												</a>
											</div>
										</div>
								 	    </div>
										<div class="text-right cursiveright cur_value pr-2">
											<div class="curBal d-flex align-items-center justify-content-end">
												<div class="cur_type mr-2" v-if="freeMargin != ''">
													<input type="text" autocomplete="off" v-model="free_Margin" name="Margin" v-validate="{required:true,max_value:freeMargin,regex: /^[.]|(?=.*[1-9])\d+(\.\d+)?$/}"/>
												</div>
												<img class="cur_icon" :src="'../../../../static/website/images/crypto_logos/'+ send.currency.toLowerCase() + '.png'" alt=""  @error="handleImgErr($event)" v-if="send != '' && checkImage(send.currency)">
												<span class="firstName" v-else-if="send != ''">{{send.currency.charAt(0)}}</span>
										   </div>
										</div>
									</div>
									<p class="cur_result text-right my-1">Balance: {{freeMargin}} {{send.currency}}</p>
									<!-- <p class="cur_result text-right my-1" v-if="'MAX' in get_depth">Max {{send.currency}}: {{get_depth.MAX}}</p> -->
									<span class="text-danger text-right d-block w-100" v-if="submitted && errors.has('Margin')">{{ (errors.first('Margin').includes('format is invalid') )?'Amount should be greater then zero':errors.first('Margin') }}</span>
									<div class="secondMiddle">
									<div class="section_title mb-0">
										<h5>Receive</h5>
									</div>
									<div class="six column">
										<div class="cursiveLeft">
										<div class="select_cur" @click.stop="showReceive = !showReceive;showSend = false">
											<div class="dropdown cap_fund cur_ico">
												<button class="no-border cap_btn dropdown-toggle" type="button">
													<img class="cp__ico" :src="'../../../../static/website/images/crypto_logos/'+ recive.toLowerCase()  +'.png'" alt="" @error="handleImgErr($event)" v-if="recive != '' && checkImage(recive)">
													<span class="firstName" v-else-if="recive != ''">{{recive.charAt(0)}}</span>
													{{recive}}
												</button>
												
											</div>
										</div>
										<div class="dropdown-menu rounded" :class="(showReceive)?'show':''">
											<div class="cur_search showReceive">
												<input type="Search" placeholder="Search here" class="searchcrypto" v-model="searchRecive" id="reciveSearch" autocomplete="off">
											</div>
											<div class="scrolling_text">
												<a class="dropdown-item" href="#" v-for="value in uniqueCurrencyList(send,searchRecive)" v-if="send.currency != value" @click.prevent="recive = value;searchRecive = ''" :class="(value == recive)?'active':''">
													<img :src="'../../../../static/website/images/crypto_logos/'+ value.toLowerCase() + '.png'" alt="" @error="handleImgErr($event)" v-if="checkImage(value)">
													<span class="firstName" v-else>{{value.charAt(0)}}</span>
												{{value}}
													 <!-- <span class="muted">{{value}}</span> -->
												</a>
											</div>
										</div>
									    </div>
										<div class="text-right cursiveright cur_value pr-2" v-if="get_depth && freeMargin">
											<div class="d-flex align-items-center justify-content-end">
												<div class="cur_type mr-2">
													<span contentEditable="false">{{numberFormat(get_depth.B * free_Margin)}}</span>
												</div>
												<div class="curr-icon">
													<img class="cur_icon" :src="'../../../../static/website/images/crypto_logos/'+ recive.toLowerCase() + '.png'" alt="" @error="handleImgErr($event)" v-if="checkImage(recive)">
													<span class="firstName"  v-else-if="recive != ''">{{recive.charAt(0)}}</span>
												</div>
												<p class="cur_result" v-if="recive == ''">Please Select Currency</p>
											</div>
										</div>

										<div class="text-right cur_value pr-2" v-else>
												<!--<img class="cur_icon" src="../../../../static/website/images/coin-2.png" alt="">-->
											<div class="cur_type">
												<span contentEditable="false" v-if="!(errors.has('Margin')) && get_depth">{{numberFormat(get_depth.B * free_Margin)}}</span>
												<p class="cur_result" v-if="recive == ''">Please Select Currency</p>
												<p class="cur_result" v-else> Please Select Another Currency</p>
											</div>
										</div>
									</div>
									<!--Received currency price-->
									<p class="cur_result d-block text-right my-1"  v-if="get_depth && freeMargin">1 {{send.currency}} ~ {{numberFormat(get_depth.B)}} {{recive}}</p>
									<!-- <div class="col-12">
										<div class="col-12 text-center mt-3">
										<input type="submit" class="uppercase cap_btn-b blue large_btn" value="Exchange">
									</div> -->
								</div>
								<div class="formSubmitButton">
									<form @submit.prevent="submitFunc('1')">
										<div class="clearfix"></div>
										<div class="receive-id mt-4">
											<p><strong> </strong></p>
											<!-- <h3 class="h3 mb-4">Fees (0.04%)</h3> -->
											<!-- <h3 class="h3 mb-4" v-if="get_depth">Total {{recive}} Purchased = {{numberFormat(get_depth.B * free_Margin)}}</h3> -->
											
											<div class="col-12 text-center mt-0 p-0">
												<input type="submit" class="uppercase cap_btn blue w-100 large_btn" value="Exchange Now" maxlength="10000000">
											</div>
										</div>
									</form>
								</div>
								</div>
								<!-- <div class="exchange_icon">
									<a href="#">
										<feather type="repeat"></feather>
									</a>
								</div> -->
							</div>
					    </div>
					</div>
				</div>
			</div>
			<div class="confirmmation-history" v-if="step == '2'">
				<div class="confirminner">
					<div class="whiteBG">
						<!--<h4>Purchasing <span>{{purchasedValue}} </span>{{recive}}</h4>-->
						<p class="sm m-0">Pending <span>{{freeMargin - free_Margin}}</span> {{send.currency}}</p>
					</div>
					<div class="priceTable">
						<table class="table sellTable m-0">
							<tbody>
								<tr>
									<th>Price</th>
									<td><span class="d-block line-height-one">{{numberFormat(expectedPrice)}}</span><a target="_blank" href="https://capitalwallet.com/faqs" class="expaneRate">Expected exchange rate</a></td>
								</tr>
								<tr>
									<th>Qty</th>
									<td>{{free_Margin}}  {{send.currency}}</td>
								</tr>
								<tr>
									<th>Estimated Commission</th>
									<td>{{ numberFormat(free_Margin * 0.005 * pairprice)}} {{commissionCurrency}}</td>
								</tr>
								<tr>
									<th>Estimated Total</th>
									<td v-if="commissionCurrency == send.currency">{{ numberFormat(parseFloat(free_Margin*expectedPrice) - (parseFloat(free_Margin * 0.005 * pairprice) * expectedPrice)) }}  {{recive}}</td>
									<td v-else>{{ numberFormat((expectedPrice * free_Margin) - parseFloat(free_Margin * 0.005 * expectedPrice)) }} {{recive}}</td>
								</tr>
							</tbody>                            
						</table>
					</div>
					<div class="form-group text-center">
						<input type="checkbox" class="cap_checkbox" id="checkbox-1" v-model="terms" name="terms" v-validate="'required'">
						<label for="checkbox-1" class="checkbox-click-target">
							<span class="checkbox-box"></span>I agree with <a target="_blank" href="http://www.capitalwallet.com/terms"><strong>Term of Use</strong></a>, <a target="_blank" href="http://www.capitalwallet.com/privacy-policy"><strong>Privacy Policy</strong></a> and <a target="_blank" href="http://www.capitalwallet.com/aml"><strong>AML/KYC</strong></a>
							<span class="text-danger d-block text-left" v-if="submitted && errors.has('terms')">Please check terms and condition </span>
						</label>
					</div>
					<div class="buttonConfirm d-flex justify-content-between">
						<a class="uppercase cap_btn blue-b" href="#" @click.prevent="step = '1'; stopTimer()">Change</a>
						<a class="uppercase cap_btn blue" :class="(orderPlacedSuccess)?'disabled':''" href="#" @click.prevent="submitFunc('2')">Confirm</a>
					</div>
			    </div>
				<p class="sm setTimer" v-if="timer > 0"> Order Time will expire in <span>{{timer}}</span> Seconds</p>
				<p class="sm setTimer" v-if="orderPlacedSuccess"> Your placed Order is pending please wait</p>
			</div>
			<div class="orderExpired d-flex align-items-center justify-content-center h-100" v-if="step == '3'">
				<div class="keepRefral">
					<!--<h4>Purchasing <span>{{purchasedValue}} </span>{{recive}}</h4>-->
					<div class="imgSteps">
						<img src="../../../../static/website/images/laptop-1.svg" alt="Icon">
						<!-- <img src="../../../../static/website/images/pending-icon.svg" alt="Icon">
						<img src="../../../../static/website/images/success-icon.svg" alt="Icon"> -->
						<h3>your order has expired</h3>
						<p>Please refresh the page. Dont't worry, we kept all of your filters and breakdowns in place</p>
					</div>
					<div class="buttonConfirm d-flex justify-content-center mt-4">
						<a class="uppercase cap_btn blue" href="#" @click.prevent="step = '1'">Replace Order</a>
					</div>
				</div>
			</div>
			<div class="orderExpired d-flex align-items-center justify-content-center h-100" v-if="step == '4'">
				<div class="keepRefral">
					<!--<h4>Purchasing <span>{{purchasedValue}} </span>{{recive}}</h4>-->
					<div class="imgSteps">
						<img src="../../../../static/website/images/success-icon.svg" alt="Icon" v-if="tempIdRecived.stat == 'OK'">
						<img src="../../../../static/website/images/laptop-1.svg" alt="Icon" v-else-if="tempIdRecived.stat == 'NOK'">
						<p>{{tempIdRecived.resp_msg}}</p>
						<!-- <p>order id :{{tempIdRecived.tempOrderId}}</p> -->
					</div>
					<div class="buttonConfirm d-flex justify-content-center mt-4">
						<router-link class="uppercase cap_btn blue" to="/transaction-history">view order</router-link>
					</div>
				</div>
			</div>
		</section>
		<section class="cap_main_chart border-0 h-100" v-else>
			<div class="row align-items-center mobStart h-100">
				<div class="col-12">
					<div class="notTrade-account w-500 mx-auto text-center">
					<alert-notification v-if="notification_msg != ''"/>
						<div class="imgTrade">
							<img src="../../../../static/website/images/4389.svg" alt="Icon">
						</div>
						<p>No trading Account Available</p>
					</div>
				</div>
			</div>
		</section>

		
	</div>

</template>

<script>
import { Const } from '@/plugins/vue-provider-cache/const.mod'
import tradingMixins from '@/plugins/trading';
// import commonAllMixins from '@/plugins/commonAll';
export default {
    name: 'exchange',
	mixins: [tradingMixins],
    data() {
        return {
        	pageLoader : false,
			combinedData : '',
			notification_msg:'',
            notification_type:'',
			send: '',
			recive: '',
			margin_list: {},
			freeMargin: '',
			free_Margin: '',

			step : '1',
			searchSend:'',
			searchRecive:'',
			subscribedCrypto:'',
			submitted: true,
			terms: false,
			purchasedValue: '',
			timer:0,
			showSend: false,
			showReceive: false,
			downloadTimer: '',
			expectedPrice: 0,
			orderPending: {},
			tempIdRecived: {},
			orderPlacedSuccess: false,
			errImage: [],
			pairprice:0,
			commissionCurrency: '',
			pairpriceB: 0,
			Combined1 : []

        }
    },
    computed:{
		get_depth(){
			try {
				this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
				return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
				.iCache.asKeysValueArray(this)
			} catch (ex) {
				return {}
			}
		},
		get_buy_sell(){
			try {
				this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
				return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
				.iCache.getCryptoCurrency(this)
			
			// }
			
			} catch (ex) {
			// console.log('OO-one [ex]', ex)
			return {}
			}
		},
	},
	watch:{
		/*tradingAccount(value){
			this.getFirstMargin()
		},*/
		send(value){
			/*let _that = this
			this._runGetMarginInfo({ 'globalParams' :{
				account_id: _that.send.act_account_id,
				demo_live: _that.tradingAccount[0].demo_live
			}, 'localParams' :{"parameter" : this} })*/
			let amount = this.formatfloat(value.amount)
			// console.log(value,amount)
			this.freeMargin = amount;
			this.free_Margin = amount;
			this.changeReciveCurr();
		},
		margin_list(value){
			if(this.$route.params.sendCurrency){
				for(let key in value){
					if(value[key].currency.toLowerCase().includes(this.$route.params.sendCurrency.toLowerCase())){
						this.send = value[key]
						this.send.act_account_id = key
					}
				}
			}else{
				let [firstKey] = Object.keys(value)
				this.send = value[firstKey]
				this.send.act_account_id = firstKey
			}
			
		},
		recive(value){
			this.subscribe();
		}
	},
	methods:{
		marginSearch(margin_list){
			if(this.searchSend == ''){
				return margin_list
			}else{
				let data = {};
				for(let key in margin_list){
					if(margin_list[key].currency.toLowerCase().includes(this.searchSend.toLowerCase())){
						data[key] = margin_list[key]
					}
				}
				return data
			}
		},
		formatfloat(num){
            if(num){
                num = parseFloat(num)
                try{
                    return math.format(num,  {notation: 'fixed'}) || '';
                }catch(e){
                    try{ return num.toFixed(8) }catch(e){ return ''}
                }
            }else{
                return 0
            }
        },
		ChangeSendData(data,act_account_id){
			this.send = data
			this.send.act_account_id = act_account_id
		},
		checkImage(val){
			return (this.errImage.includes(val))?false:true
		},
		weightedMean(arrValues, arrWeights){
		      var result = arrValues.map(function (value, i) {
		      var weight = arrWeights[i];
		      var sum = value * weight;
		      return [sum, weight];
		    }).reduce(function (p, c) {

		      return [p[0] + c[0], p[1] + c[1]];
		    }, [0, 0]);

		    return result[0] / result[1];
		},
		handleImgErr(val){
			var fullSrc = val.target.src.split(".")
			var src = fullSrc[fullSrc.length-2].split("/")
			var img = src[src.length - 1]
			if(!this.errImage.includes(img)){
				this.errImage.push(img)
			}
		},
		subscribe(){
			if(this.send == '' || this.recive == ''){
				this.subscribedCrypto = ''
			}else{
				let dataArr2 = this.send.currency+'-'+this.recive
				let dataArr1 = this.recive+'-'+this.send.currency
				if(this.combinedCurrency.includes(dataArr1)){
					this.subscribedCrypto = dataArr1
					this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
					.seeders['S_PF_PF'].subscribe([dataArr1])
				}else if(this.combinedCurrency.includes(dataArr2)){
					this.subscribedCrypto = dataArr2
					this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
					.seeders['S_PF_PF'].subscribe([dataArr2])
				}else{
					this.subscribedCrypto = ''
					this.displayError('no key found','error')
				}
			}
		},
		/*getFirstMargin(){
			if(this.tradingAccount.length > 0 && this.tradingAccount[0].subAccounts.length > 0){
				this.send = this.tradingAccount[0].subAccounts[0]
				// this.changeReciveCurr()
			}
		},*/
		changeReciveCurr(){
			// console.log('Currency-changed',this.send)
			if(this.uniqueCurrencyList(this.send).length > 0 ){
				if(this.$route.params.receiveCurrency){
					this.recive = this.$route.params.receiveCurrency
					delete this.$route.params.receiveCurrency
					// console.log('parms after clear',this.$route.params)
				}else{
					if(this.send.currency == this.uniqueCurrencyList(this.send)[0]){
						this.recive = this.uniqueCurrencyList(this.send)[1]
					}else{
						this.recive = this.uniqueCurrencyList(this.send)[0]
					}
				}
			}else{
				this.subscribe();
			}
		},
		uniqueCurrencyList(val,search){
			if(val!= '' && Object.keys(val).length > 0 && this.Combined1.length > 0){
				// for(var key in )
				// let combine = this.combinedCurrency.filter( val=> val.toLowerCase().includes(this.send.currency.toLowerCase()))
				var unique = []
				
				for(var key in this.Combined1){
					if(parseInt(this.Combined1[key].Spread) == 1){
						let data = this.Combined1[key].isinid
						if (data.includes("-") && data.split("-").includes(val.currency)) {
							unique = unique.concat(data.split("-"));
						}
					}
					
				}
				unique = [...new Set(unique)].sort().filter(val=>{
		            return !['XMR','ZEC','DASH','XVG','ZEN','XRP','BEAM'].includes(val.toUpperCase())
		        });
				if(search && search != ''){
					return unique.filter(val => val.toLowerCase().includes(this.searchRecive.toLowerCase()))
				}
				return unique
			}else{
				return []
			}
		},
		currencyListFunc(type){
			if(type == 'send'){
				if(this.searchSend == ''){
					return this.tradingAccount[0].subAccounts
				}else{
					return this.tradingAccount[0].subAccounts.filter(val => val.currency.toLowerCase().includes(this.searchSend.toLowerCase()))
				}
			}else if(type == 'recive'){
				if(this.searchRecive == ''){
					return this.uniqueCurrency
				}else{
					return this.uniqueCurrency.filter(val => val.toLowerCase().includes(this.searchRecive.toLowerCase()))
				}
			}
		},
		submitFunc(step){
			const _that = this
			_that.submitted = true;
			if(_that.get_depth && step == '1'){
				const MaxBuy = this.get_depth.MAX
				_that.$validator.validate().then(valid => {
					if (valid && MaxBuy > _that.free_Margin) {
						this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']

						// get_depth.B * free_Margin
						const price = this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.CheckOrderEligibilty(this)
						_that.step = '2'
						_that.purchasedValue = price.B * _that.free_Margin
						_that.expectedPrice = price.B
						_that.submitted = false;

						let dataArr2 = this.send.currency+'-'+this.recive
						// let dataArr2 = this.recive+'-'+this.send.currency
						_that.pairprice = price.B
						_that.pairpriceB = price.B
						_that.commissionCurrency = this.recive
						if(!(this.combinedCurrency.includes(dataArr2))){
							_that.pairprice = 1
							_that.pairpriceB  = 1/_that.pairpriceB 
							_that.commissionCurrency = this.send.currency
						}
						_that.startTimer()
					}else{
						// alert("Invalid amount")
						this.displayError('You can buy maximum of '+MaxBuy,'error')
					}
				});
			}else if(step == '2'){
				_that.$validator.validate().then(valid => {
					if (valid) {
						const tempOrderId = new Date().getTime()

						// let expQty = _that.purchasedValue + parseFloat(this.free_Margin * 0.005 * this.pairprice)

						// let expQty = 0

						// if(this.commissionCurrency == this.send.currency){ 

						// 	 // numberFormat(free_Margin * 0.005 * pairprice) this.commissionCurrency

						// 	// 1.5900756130072784 / 1.005 / 220.00398980

						// 	expQty = parseFloat(this.free_Margin/ 1.005 / (1/_that.expectedPrice))
							
						// 	// expQty = expQty * this.expectedPrice
						// 	// expQty = (this.free_Margin*this.expectedPrice) - ((this.free_Margin * 0.005 * this.pairprice) * this.expectedPrice)
						// }  
						// else{ 
						// 	expQty = this.free_Margin
						// }

						// expQty = parseFloat(expQty).toFixed(8)

						let orderJson = {
							"symbol": _that.recive +"-"+_that.send.currency,
							"quantity": _that.free_Margin,
							"side":"1",
							"type":"L",
							"price":_that.expectedPrice,
							"tempOrderId": tempOrderId,
							"account_id": this.tradingAccount[0].account_id,
							'localParams':_that
						}
						this.orderPending = orderJson
						this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
							.seeders['S_PF_PF'].placeOrder(orderJson)
						this.stopTimer()
					}
				});
			}
		},
		successWs(){
			this.orderPlacedSuccess = true
			let _that = this
			let Timer = setInterval(function(){
				let orderMessage = localStorage.getItem('orderMessage')
				if(orderMessage){
					let data = JSON.parse(orderMessage)
					if(data.tempOrderId == _that.orderPending.tempOrderId){
						_that.orderPlacedSuccess = false
						_that.displayError(data.resp_msg,'success')
						_that.tempIdRecived = data;
						_that.step = '4'
						localStorage.removeItem('orderMessage');
						clearInterval(Timer);
					}
				}
			}, 500);
        },
		startTimer(){
			var timeleft = 15;
			var _that = this;
			this.downloadTimer = setInterval(function(){
				if(timeleft <= 0){
					clearInterval(_that.downloadTimer);
					_that.step = '3'
				}
				_that.timer = timeleft;
				timeleft -= 1;
			}, 1000);
		},
		stopTimer(){
			clearInterval(this.downloadTimer);
			this.timer = 0;
		},
        failedWs(){
			this.displayError('faild to Place order','error')
            // console.log('failed')
        },
		displayError(getMessage,type){
			/*this.$notify({
				group: 'foo',
				type: (type && type == null)?'error':type,
				text: getMessage,
				duration: 2000,
				closeOnClick: true,
				position: "center bottom"
			});*/
			var _that = this
			try{
		        _that.notification_msg = getMessage ;
		        _that.notification_type = type ;

		        setTimeout(function(){
		            _that.notification_msg = '' ;
		            _that.notification_type = '' ;
		        }, 5000);
		    }catch(e){}
		}
	},
	created(){
		this.pageName('EXCHANGE')
		this._runGetMarginInfo({ 'globalParams' :{}, 'localParams' :{"parameter" : this,'page':'exchange'} })
		this._runCryptoList({ 'globalParams' :{}, 'localParams' :{"parameter" : this,'page':'exchange'} })
		// this.getFirstMargin()
	},
	updated(){
		if(this.showSend){
			document.getElementById("sendSearch").focus();
		}else if(this.showReceive){
			document.getElementById("reciveSearch").focus();
		}
	},
	mounted() {
		const _that = this
        $(document).on("click", function(event){
			if(!$(event.target).closest('.showReceive').length){
                _that.showReceive = false
            }
			
            if(!$(event.target).closest('.showSend').length){
                _that.showSend = false
            }
        });
	}
}
</script>



// WEBPACK FOOTER //
// src/components/website/trading/exchange.vue